function reasonForVisit(props: any) {
    const {
        characterLimit,
        reasonForVisit,
        reasonForVisitLabel,
        fieldValidation,
        handleChange
    }: {
            characterLimit: number,
            reasonForVisit: string,
            reasonForVisitLabel: string,
            fieldValidation: { [key: string]: { valid: boolean } },
            handleChange: Function
    } = props;

    return (
        <div className="form-group">
            {reasonForVisitLabel &&
                <div>{reasonForVisitLabel}</div>
            }
            <textarea maxLength={characterLimit} className="form-control" id="reasonForVisit" name="reasonForVisit" rows={7} value={reasonForVisit} onChange={(e) => { handleChange(e, 'String') }} />
            {characterLimit > 0 &&
                <div><span>{reasonForVisit.length || 0}/{characterLimit}</span></div>
            }
            {fieldValidation["reasonForVisit"].valid === false &&
                <div><span style={{ "color": "red" }}>* Please enter a reason for your visit</span></div>
            }
        </div>
    );
}

export default reasonForVisit;